import React from 'react';

import CompanyTabContent from '../shared/CompanyTabContent';
import BusinessInvolvements from './BusinessInvolvements';
import Carbon from './Carbon/Carbon';
import Controversies from './Controversies';
import SanctionsList from './SanctionsList';
import SustainableImpact from './SustainableImpact';

const CompanyIssues: React.FC = () => {
  return (
    <CompanyTabContent isLoading={false}>
      <BusinessInvolvements />
      <SanctionsList />
      <Controversies />
      <Carbon />
      <SustainableImpact />
    </CompanyTabContent>
  );
};

export default CompanyIssues;
